import { useNavigate } from 'react-router-dom';
import { BotIcon } from '../../assets/Icons/BotIcon';
import styles from './McpChatHeaderItem.module.css';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { mcpChatTranslationRef } from '../../translation';

export const McpChatHeaderItem = () => {
  const navigate = useNavigate();
  const { t } = useTranslationRef(mcpChatTranslationRef);

  return (
    <button className={styles.button} onClick={() => navigate('/xpert')}>
      <BotIcon />
      {t('headerItem.askXpert')}
    </button>
  );
};
